import { apiClient } from '../client/apiClient';
import type { IBaseResponse } from '../types/common';
import type { ILocation } from '../types/user';

export const locationService = {
	/**
	 * Get list of locations
	 */
	listLocations: () =>
		apiClient.get<IBaseResponse<ILocation[]>>('/locations/list'),
};
